<template lang="html">
  <router-view v-if="hasSubTopic"/>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      'hasSubTopic': 'speakupFeedback/hasSubTopic',
      'speakUp': 'speakupFeedback/getSpeakUp'
    }),
  },
  methods: {
    ...mapMutations({
      setShowLoader: 'setShowLoader',
      setSubTopic: 'speakupFeedback/setSubTopic',
    }),
    ...mapActions({
      getSubTopic: 'speakupFeedback/getSubTopic',
    })
  },
  async mounted () {
    try {
      this.setShowLoader(true)

      await this.getSubTopic(this.$route.params)

      if (!this.hasSubTopic || this.speakUp.status === 'A') {
        this.setShowLoader(false)
        this.$router.replace(`/speakup-feedback/${this.$route.params.class_id}?email=${this.$route.query.email}`)
        return
      }

      this.setShowLoader(false)
    } catch (error) {
      console.log(error)
      this.setShowLoader(false)
      this.$router.replace(`/speakup-feedback/${this.$route.params.class_id}?email=${this.$route.query.email}`)
    }
  },
  beforeDestroy () {
    this.setSubTopic(null)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/speakUpFeedback/subTopic.vue